import React from "react";

import "./LeaderboardPreview.css";

import {

    Trophy,

    Zap,

    Brain,

    Eye,

    Target,

    ArrowRight

} from "lucide-react";

import {

    useNavigate

} from "react-router-dom";

const LeaderboardPreview = () => {

    const navigate =
        useNavigate();

    const leaderboardTypes = [

        {

            title:"Reaction",

            icon:<Zap size={24}/>,

            color:"#2563EB",

            route:"/leaderboard?metric=reaction"

        },

        {

            title:"Memory",

            icon:<Brain size={24}/>,

            color:"#10B981",

            route:"/leaderboard?metric=memory"

        },

        {

            title:"Vision",

            icon:<Eye size={24}/>,

            color:"#F59E0B",

            route:"/leaderboard?metric=visual"

        },

        {

            title:"Anticipation",

            icon:<Target size={24}/>,

            color:"#EC4899",

            route:"/leaderboard?metric=anticipation"

        }

    ];

    return(

        <div className="arena-leaderboard">

            <div className="arena-leaderboard-header">

                <div>

                    <h2>

                        Test Leaderboards

                    </h2>

                    <p>

                        Compete in every assessment individually.

                    </p>

                </div>

                <Trophy size={34}/>

            </div>

            <div className="leaderboard-grid">

                {

                    leaderboardTypes.map(

                        (item,index)=>(

                            <div

                                key={index}

                                className="leaderboard-card"

                            >

                                <div

                                    className="leaderboard-icon"

                                    style={{

                                        background:item.color

                                    }}

                                >

                                    {item.icon}

                                </div>

                                <h3>

                                    {item.title}

                                </h3>

                                <p>

                                    View rankings and compare your performance.

                                </p>

                                <button

                                    onClick={()=>

                                        navigate(

                                            item.route

                                        )

                                    }

                                >

                                    View Leaderboard

                                    <ArrowRight size={16}/>

                                </button>

                            </div>

                        )

                    )

                }

            </div>

        </div>

    );

};

export default LeaderboardPreview;